module.exports = __webpack_public_path__ + "img/icon-exit-white.55f5857f.svg";